import config from '../config';
import Logger from '../logger';
import event from '../mixins/event';

class ThemeMobileHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeMobileHeader';

		this.dom = dom;
		this.mobileCheckboxDom = document.querySelector(`[data-theme-mobile-header-checkbox]`);
	}

	/**
	 * init - Initialize the header
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initMobileCheckbox();
	}

	/**
	 * initMobileCheckbox - Initialize the mobile checkbox
	 */
	initMobileCheckbox() {
		Logger.info(`${this.NAME} > initMobileCheckbox`);

		if (!this.mobileCheckboxDom) return;

		this.mobileCheckboxDom.addEventListener('change', this.onMobileCheckboxChange.bind(this));
	}

	/**
	 * onMobileCheckboxChange - When the mobile checkbox is changed
	 */
	onMobileCheckboxChange(event) {
		Logger.info(`${this.NAME} > onMobileCheckboxChange`);
		this.trigger(`ThemeMobileHeader:mobile_checkbox_changed`, {
			checked: event.target.checked
		});
	}
}

Object.assign(ThemeMobileHeader.prototype, event);

export default ThemeMobileHeader;
